import React, { useEffect, useState } from 'react';
import { actions } from 'redux/actions';
import Shared from 'screens/shared';

import { ACTIONS_TYPES } from 'redux/helper';
import { resourceIconMap, _t } from 'utils';
import { useSelector } from 'react-redux';
import useFilter from './hooks/resource-filter';

export default ({ groupId }) => {
  const [deleteId, setDeleteId] = useState('');
  const [resources, FilterComponent] = useFilter();
  const { listViewType = '' } = useSelector((e) => e);

  const fields = [
    {
      name: 'resource',
      type: 'resource',
      style: { marginTop: 15 },
    },
  ];

  const addResourceToGroup = (resourceId) => {
    actions.group.addResource({ groupId, resourceId });
  };

  const CreateForm = () => (
    <Shared.forms.Form
      fields={fields}
      fieldsValues={{}}
      onSubmit={({ resource: { id = '' } }) => addResourceToGroup(id)}
      isCancel={false}
    />
  );

  useEffect(() => {
    actions.group.getResouces({ groupId });
    actions.user.getAllResources();
  }, [groupId]);

  const selectToDelete = (id) => {
    setDeleteId(id);
  };

  const onDeleteResource = (confirmState) => {
    if (confirmState) {
      actions.group.deleteResouce({ resourceId: deleteId, groupId });
    }
    setDeleteId('');
  };

  return (
    <div style={{ marginTop: 20 }}>
      <Shared.widgets.Cards
        title={_t('Resources')}
        type="common"
        onFilter={() => ''}
        filterRender={FilterComponent}
        addAction={ACTIONS_TYPES.GROUP.ADD_RESOURCE}
        addRender={<CreateForm />}
        isToggleButton
        isEmpty={!resources.length}
      >
        {listViewType === 'table' ? (
          <Shared.widgets.TableView
            name="servers"
            rows={
              resources.map((resource) => {
                const { properties, id, type } = resource;
                const {
                  name,
                } = properties;

                return ([
                  <Shared.widgets.Icon name={resourceIconMap(type)} />,
                  name,
                  type,
                  <Shared.widgets.Icon name="trash" onClick={() => selectToDelete(id)} style={{ color: 'var(--color-danger)' }} />,
                ]);
              })
            }
            columns={[
              { name: '' },
              { name: 'Name' },
              { name: 'Type' },
              { name: '' },
            ]}
          />
        ) : (resources.map((resource) => {
          const { properties, id, type } = resource;
          const {
            name,
          } = properties;

          return (
            <Shared.widgets.CardBasic
              key={id}
              icon={resourceIconMap(type)}
              title={name}
              details={type}
              actionButtons={{
                delete: () => selectToDelete(id),
              }}
            />
          );
        }))}
      </Shared.widgets.Cards>
      <Shared.dialog.Confirm show={!!deleteId} onClose={onDeleteResource} />
    </div>
  );
};
